<div [formGroup]="formGroup">
  <div class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.type' | translate}}</mat-label>
      <mat-select [value]="value.type"
                  [(ngModel)]="value.type"
                  [formControlName]="'typeField'"
                  (click)="showOverlay()"
                  (ngModelChange)="inputEmit()">
        <mat-option *ngFor="let option of editTypeOptions" [value]="option.value">{{'objects.' + option.label | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="value.type === 'dynamic-editable'" class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.inputType' | translate}}</mat-label>
      <mat-select [value]="value.inputType"
                  [(ngModel)]="value.inputType"
                  [formControlName]="'inputTypeField'"
                  (click)="showOverlay()"
                  (ngModelChange)="inputEmit()">
        <mat-option *ngFor="let option of inputTypeOptions" [value]="option.value">{{'objects.' + option.label | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="value.type === 'static' || value.type === 'dynamic-editable'" class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.text' | translate}}</mat-label>
      <input matInput type="text"
             autocomplete="off"
             [value]="value.text"
             [(ngModel)]="value.text"
             [formControlName]="'textField'"
             (click)="showOverlay()"
             (blur)="hideOverlay()"
             (ngModelChange)="inputEmit()" />
    </mat-form-field>
  </div>

  <div *ngIf="value.type === 'dynamic' || value.type === 'dynamic-editable'" class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.dynamicId' | translate}}</mat-label>
      <mat-select [value]="value.dynamicId"
                  [(ngModel)]="value.dynamicId"
                  [formControlName]="'dynamicIdField'"
                  (click)="showOverlay()"
                  (ngModelChange)="inputEmit()">
        <mat-option *ngIf="value.type === 'dynamic-editable'" [value]="null">-{{'propertypreviewEditor.none' | translate}}-</mat-option>
        <mat-option *ngFor="let option of dynamicIdOptions" [value]="option.value">{{'objects.' + option.label | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="value.type === 'dynamic-editable'" class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.editableId' | translate}}</mat-label>
      <input matInput type="text"
             autocomplete="off"
             [value]="value.editableId"
             [(ngModel)]="value.editableId"
             [formControlName]="'editableIdField'"
             (click)="showOverlay()"
             (blur)="hideOverlay()"
             (ngModelChange)="inputEmit()" />
      <mat-error align="start" *ngIf="value.editableId?.length === 0 || value.editableId?.length === null">
        <font>{{'propertypreviewEditor.required' | translate}}</font>
      </mat-error>
    </mat-form-field>
  </div>

  <div *ngIf="value.type === 'dynamic-editable'" class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.maxLength' | translate}}</mat-label>
      <input matInput type="text"
             autocomplete="off"
             [value]="value.validation.maxLength"
             [(ngModel)]="value.validation.maxLength"
             [formControlName]="'maxLengthField'"
             (click)="showOverlay()"
             (blur)="hideOverlay()"
             (ngModelChange)="inputEmit()" />
    </mat-form-field>
  </div>

  <div *ngIf="value.type === 'dynamic-editable'" class="select-input-field">
    <mat-checkbox class="mr-1"
            [checked]="value.validation.required"
            [(ngModel)]="value.validation.required"
            [formControlName]="'requiredField'"
            (change)="onChangeAtCheckBox($event)"
            (ngModelChange)="inputEmit()">
     {{'objects.required' | translate}}
    </mat-checkbox>
  </div>

  <div *ngIf="value.type === 'dynamic-editable' && (value.inputType === 'select' || value.inputType === 'multiSelect')" class="select-input-field" appearance="fill">
    {{'objects.options' | translate}}
    <button mat-button color="primary" (click)="addObject()" [disabled]="false">
      <mat-icon aria-label="">add_box</mat-icon>
    </button>
    <mat-error align="start" *ngIf="value.options === null || this.value.options.length === 0">
      <font>{{'propertypreviewEditor.required' | translate}}</font>
    </mat-error>
  </div>

  <div *ngIf="value.type === 'dynamic-editable' && (value.inputType === 'select' || value.inputType === 'multiSelect') && this.value.options?.length > 0" class="p-3 select-input-field">
    <mat-table #dragDropTable [dataSource]="optionDataSource" cdkDropList [cdkDropListData]="optionDataSource" (cdkDropListDropped)="dropTable($event)">
      <ng-container matColumnDef="label">
        <mat-header-cell *matHeaderCellDef> {{'propertypreviewEditor.label' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let option; let i = index;">
          <div>
            <mat-form-field class="option-input property-form-field" floatLabel="never" fxFlex="grow">
              <mat-label>{{'propertypreviewEditor.label' | translate}}</mat-label>
              <input matInput maxlength="{{value.validation.maxLength}}" [value]="option.label" [(ngModel)]="option.label" [ngModelOptions]="{standalone: true}"
                     (change)="onChangeAtMulti()">
              <mat-error align="start" *ngIf="option.label?.length === 0 || option.label?.length === null">
                <font>{{'propertypreviewEditor.required' | translate}}</font>
              </mat-error>
            </mat-form-field>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="value">
        <mat-header-cell class="header-align-left" *matHeaderCellDef> {{'propertypreviewEditor.value' | translate}} </mat-header-cell>
        <mat-cell class="align-left" *matCellDef="let option; let i = index;">
          <div>
            <mat-form-field class="option-input property-form-field" floatLabel="never" fxFlex="grow">
              <mat-label>{{'propertypreviewEditor.value' | translate}}</mat-label>
              <input matInput maxlength="{{value.validation.maxLength ? value.validation.maxLength : 0}}" [value]="option.value" [ngModelOptions]="{standalone: true}"
                     [(ngModel)]="option.value" (change)="onChangeAtMulti()">
              <mat-error align="start" *ngIf="option.value?.length > value.validation.maxLength">
                <font>{{'propertypreviewEditor.overLength' | translate}}</font>
              </mat-error>
              <mat-error align="start" *ngIf="option.value?.length === 0 || option.value?.length === null">
                <font>{{'propertypreviewEditor.required' | translate}}</font>
              </mat-error>
            </mat-form-field>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="position">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let option; let i = index;" class="align-end">
          <div fxLayout="row" fxLayoutAlign="end end">
            <button mat-button color="primary">
              <mat-icon cdkDragHandle>drag_indicator</mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let option; let i = index;">
          <div fxLayout="row" fxLayoutAlign="end end" class="align-end">
            <button mat-button color="warn" (click)="deleteObject(i)">
              <mat-icon aria-label="">delete</mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="['label','value','delete', 'position']; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: ['label','value','delete', 'position'];" cdkDrag [cdkDragData]="row"></mat-row>
    </mat-table>
  </div>

  <div *ngIf="value.type === 'dynamic-editable' && value.inputType === 'radio'" class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.radioType' | translate}}</mat-label>
      <mat-select [value]="value.radioType"
                  [(ngModel)]="value.radioType"
                  [formControlName]="'radioTypeField'"
                  (click)="showOverlay()"
                  (ngModelChange)="inputEmit()">
        <mat-option *ngFor="let option of radioTypeOptions" [value]="option.value">{{'objects.' + option.label | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="value.type === 'dynamic-editable' && value.inputType === 'radio'" class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.radioLabel' | translate}}</mat-label>
      <input matInput type="text"
             autocomplete="off"
             [value]="value.radioLabel"
             [(ngModel)]="value.radioLabel"
             [formControlName]="'radioLabelField'"
             (click)="showOverlay()"
             (blur)="hideOverlay()"
             (ngModelChange)="inputEmit()" />
    </mat-form-field>
  </div>

  <div *ngIf="value.type === 'dynamic-editable' && value.inputType === 'radio'" class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.value' | translate}}</mat-label>
      <input matInput type="text"
             autocomplete="off"
             [value]="value.value"
             [(ngModel)]="value.value"
             [formControlName]="'valueField'"
             (click)="showOverlay()"
             (blur)="hideOverlay()"
             (ngModelChange)="inputEmit()" />
    </mat-form-field>
  </div>

  <div *ngIf="value.type === 'dynamic-editable' && value.inputType === 'multiSelect'" class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.multiSelectDelimiter' | translate}}</mat-label>
      <mat-select [value]="value.multiSelectDelimiter"
                  [(ngModel)]="value.multiSelectDelimiter"
                  [formControlName]="'multiSelectDelimiterField'"
                  (click)="showOverlay()"
                  (ngModelChange)="inputEmit()">
        <mat-option *ngFor="let option of delimiterOptions" [value]="option.value">{{'objects.' + option.label | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="value.type === 'dynamic-editable'" class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.label' | translate}}</mat-label>
      <input matInput type="text"
             autocomplete="off"
             [value]="value.label"
             [(ngModel)]="value.label"
             [formControlName]="'labelField'"
             (click)="showOverlay()"
             (blur)="hideOverlay()"
             (ngModelChange)="inputEmit()" />
    </mat-form-field>
  </div>

  <div *ngIf="value.type === 'dynamic-editable'" class="select-input-field">
    <mat-form-field appearance="fill">
      <mat-label>{{'objects.inputGroup' | translate}}</mat-label>
      <input matInput type="text"
             autocomplete="off"
             [value]="value.inputGroup"
             [(ngModel)]="value.inputGroup"
             [formControlName]="'inputGroupField'"
             (click)="showOverlay()"
             (blur)="hideOverlay()"
             (ngModelChange)="inputEmit()" />
    </mat-form-field>
  </div>
</div>
